// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Gu4Ud","closeButton":"modal_closeButton__82xnG"};